export default "__VITE_ASSET__B16IqoYH__"